import { IsInt, IsNotEmpty, IsString } from 'class-validator';

export class OrderDialogUserMessageRequestDto {
  @IsNotEmpty()
  @IsString()
  text: string;

  @IsNotEmpty()
  @IsInt()
  orderId: number;
}